import { render, staticRenderFns } from "./AlertFormComponent.vue?vue&type=template&id=b14f9d5e&scoped=true&"
import script from "./AlertFormComponent.vue?vue&type=script&lang=ts&"
export * from "./AlertFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AlertFormComponent.vue?vue&type=style&index=0&id=b14f9d5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14f9d5e",
  null
  
)

export default component.exports